module.exports = __webpack_public_path__ + "img/maquette.0cd1da81.jpg";